var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-page d-flex"},[_c('div',{staticClass:"user-page--content px-2 py-2 px-md-4 py-md-4"},[(_vm.$auth.isAuthenticated)?_c('UserInfo'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }